import posthog from 'posthog-js';

let isPostHogInitialized = false;

export interface PostHogUserProperties {
  email?: string;
  role?: string;
}

/**
 * `defaults: '2026-05-30'` sets `capture_pageview` to `history_change`, so the
 * first load and later React Router navigations emit `$pageview` on their own.
 */
export const initializePostHog = (): void => {
  if (isPostHogInitialized) {
    return;
  }

  const apiKey = process.env.REACT_APP_POSTHOG_KEY;
  const apiHost = process.env.REACT_APP_POSTHOG_HOST;
  if (!apiKey || !apiHost) {
    return;
  }

  posthog.init(apiKey, {
    api_host: apiHost,
    defaults: '2026-05-30',
    person_profiles: 'identified_only',
    cross_subdomain_cookie: true,
    persistence: 'localStorage+cookie',
  });
  isPostHogInitialized = true;
};

export const identifyPostHogUser = (userId: string, properties: PostHogUserProperties = {}): void => {
  if (!isPostHogInitialized || !userId) {
    return;
  }

  posthog.identify(userId, {
    ...(properties.email && { email: properties.email }),
    ...(properties.role && { role: properties.role }),
  });
};

export const resetPostHog = (): void => {
  if (!isPostHogInitialized) {
    return;
  }

  posthog.reset();
};
